export const environment = {
  production: false,
  smartPerformanceApiServer: "https://raioxdemercado.com:8081/api",
  smartPerformanceApiLocal: "http://localhost:4013/api",
  apiUrl: "https://raioxdemercado.com:8081/api",
  accessToken:
    "jl9QcdPRbFRml5s7FNyjNLJLkPa7hiagSSZDjGZjnNR964ub5tRmGRg75Q1bc9I4",
};
